<!-- <div class="litmus-alert-container">
    <div class="litmus-alert-model">
        <div class="litms-alert-header">
            asdfasdfasdfasdfasdfasdf
        </div>
        <div class="litms-alert-body">
    asdfasdfasdfasdf
        </div>
        <div class="litms-alert-footer">
    asdfasdfasfdasfdasdf
        </div>
    </div>
</div> -->

<div class="modal modal-dialog-centered confirm-message-modal" id="confirmMessageModal" role="dialog" *ngIf="showModel">
  <div class="modal-dialog" role="document">
    <div class="modal-content usr-setting-pop-up-field">
      <div class="modal-header">
        <span class="modal-title confirm-message-modal-header" [innerHTML]="title">
        </span>
        <span *ngIf="description && description != ''" class="modal-title confirm-message-modal-description">
          {{description}}
        </span>
      </div>
      <div class="modal-body confirm-message-modal-body" [innerHTML]="content"></div>
      <div class="modal-footer">
        <button type="button" *ngFor="let btn of buttons" class="btn action-buttion message-btn-{{btn.type}}"
          (click)="onClick(btn.key||btn.text)">
          {{btn.text}}
        </button>
      </div>
    </div>
  </div>
</div>